import { default as cookies } from '_cookies.js';

const breakpoint = 760;
const quizCookieName = 'dismissedModalSC2K3T';
const quizModal = document.getElementById('quizModal');


/**
 *
 *
 */
const init = function () {

	// cookies.eraseCookie(quizCookieName);

	// if the model box is not present on the page, bail now
	if (quizModal === null) {
		return;
	}

	// only launch the modal if above the mobile breakpoint
	if (getWindowWidth() >= breakpoint) {
		displayDesktopModal();
	} else {
		displayMobileModal();
		setModalCookie();
	}

};


/**
 *
 *
 *
 */
const getWindowWidth = function () {

	const win = window;
	const doc = document;
	const docElem = doc.documentElement;
	const body = doc.getElementsByTagName('body')[0];
	const x = win.innerWidth || docElem.clientWidth || body.clientWidth;

	return x;

};


/**
 *
 *
 *
 */
const displayTheModel = function () {

	if (cookies.getCookie(quizCookieName) == 1) {
		return false;
	}

	if ($('body').hasClass('single-quiz')) {
		setModalCookie();
		return false;
	}

	return true;

};


/**
 *
 *
 *
 */
const displayMobileModal = function () {

	// bail if cookies are not supported
	if (!Modernizr.cookies) {
		return;
	}

	const modal = document.getElementById('quizModal');
	const close = document.getElementById('modalHideButton');

	if (displayTheModel()) {

		modal.style.display = 'block';
		close.setAttribute('aria-expanded', 'true');

		close.addEventListener('click', () => {
			modal.style.display = 'none';
			close.setAttribute('aria-expanded', 'false');
		});

	}

};


/**
 *
 *
 *
 */
const displayDesktopModal = function () {

	const modalDelay = 3000;

	// bail if cookies are not supported
	if (!Modernizr.cookies) {
		return;
	}

	// check for quiz modal cookie
	if (displayTheModel()) {

		setTimeout(() => {
			$.fancybox.open({
				src: '#quizModal',
				type: 'inline',
				opts: {
					afterShow: function () {
						setModalCookie();
					}
				}
			});
		}, modalDelay);

	}

};


/**
 *
 *
 *
 */
const setModalCookie = function () {

	// name, value, duration in days
	cookies.setCookie(quizCookieName, 1, 999);

};


const api = {
	init: init
};

export default api;